// extracted by mini-css-extract-plugin
export default {"pageHeaderWithBack":"styles_pageHeaderWithBack__JfBME","backButton":"styles_backButton__aRZYL","label":"styles_label__i7nKu"};